import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoalService } from 'app/services/coal.service';
import { SharedService } from 'app/shared.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-contenedor',
    templateUrl: './contenedor.component.html',
    styleUrls: ['./contenedor.component.scss']
})
export class ContenedorComponent implements OnInit {
    @Input() id: any;
    @Input() contenedor: any;
    FormCarro: FormGroup;

    opcionesTipoContenedor: Observable<any[]>;
    lstTipoContenedor: any;

    constructor(
        private formBuilder: FormBuilder,
        private sharedService: SharedService,
        private srvcoal: CoalService,
    ) {

    }

    ngOnInit() {
        this.GetContenedores()
        this.FormCarro = this.formBuilder.group({
            id: [''],
            TipoContenedor: ['', Validators.required],
            PesoContenedorVacio: ['', Validators.required],
            PesoNetoMercancia: ['', Validators.required]
        });

        this.FormCarro.controls.id.setValue( this.id.id )
        this.FormCarro.valueChanges.subscribe(changes => {
            if (this.FormCarro.valid) {
                // console.log("Validacion Carro Contenedor: ", this.FormCarro.value);
                this.sharedService.setFormFerroviariosCarroContenedor(changes);
            }
        });

       
    }

    GetContenedores() {
        this.srvcoal.getService(`cat-tipo-contenedores`,).subscribe((res: any) => {
            if (res.err) {
                // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                // this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                this.lstTipoContenedor = res.data;
                if (this.contenedor) {
                    this.FormCarro.patchValue({
                        TipoContenedor: this.contenedor.TipoContenedor,
                        PesoContenedorVacio: this.contenedor.PesoContenedorVacio,
                        PesoNetoMercancia: this.contenedor.PesoNetoMercancia,
                    });
                }
                this.opcionesTipoContenedor = this.FormCarro.get('TipoContenedor').valueChanges.pipe(
                    startWith(''),
                    map(state => (state ? this._filtrarTipoContenedor(state) : this.lstTipoContenedor)),
                );


            }
            // this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            // this.store.dispatch(OcultarSpinner())
        });
    }

    displayTipoContenedor = (bienes: any): string => {
        const servicioEncontrado = this.lstTipoContenedor.find((f: any) => f.id === bienes);
        if (servicioEncontrado) {
            return `${servicioEncontrado.attributes.clave} - ${servicioEncontrado.attributes.tipo}`;
        } else {
            return '';
        }
    }

    private _filtrarTipoContenedor(value: any): any[] {
        const filterValue = value?.toLowerCase();

        return this.lstTipoContenedor.filter(unidad =>
        (unidad.attributes.clave.toLowerCase().includes(filterValue) ||
            unidad.attributes.tipo.toLowerCase().includes(filterValue))
        );
    }

}
